/**
 * RequireRole, plus: a scheduling delegate (migration 1780) of any role may open the route. Used only for the
 * scheduling surfaces (Sales Calendar, team availability, the delegate's Confirm Schedule page). The database decides
 * what they can read and change on those pages.
 */
import React from "react";
import { RequireRole, useAuth } from "../../contexts/AuthContext";
import { useSchedulingDelegations } from "../../hooks/useSchedulingDelegations";
import { normalizeRole } from "../../utils/roleUtils";

interface Props {
  children: React.ReactNode;
  allowedRoles: string[];
}

export default function RequireRoleOrSchedulingDelegate({
  children,
  allowedRoles,
}: Props) {
  const { user } = useAuth();
  const { isDelegate, isLoading } = useSchedulingDelegations();
  const roleAllowed = allowedRoles
    .map(normalizeRole)
    .includes(normalizeRole(user?.role));
  if (!roleAllowed && isLoading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  if (!roleAllowed && isDelegate) {
    return <>{children}</>;
  }
  return <RequireRole allowedRoles={allowedRoles}>{children}</RequireRole>;
}
